import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ActionAssignmentTurnedIn from 'material-ui/svg-icons/action/assignment-turned-in'
import ActionAssignmentLate from 'material-ui/svg-icons/action/assignment-late'
import ActionDone from 'material-ui/svg-icons/action/done'
import ActionBook from 'material-ui/svg-icons/action/book'
import ActionDoneAll from 'material-ui/svg-icons/action/done-all'
import ActionCreditCard from 'material-ui/svg-icons/action/credit-card'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import { push as pushAction } from 'react-router-redux'
import { refreshView as refreshViewAction } from '../actions/uiActions'
import {
	accountConfirmTransmittal as accountConfirmTransmittalAction,
	accountRejectTransmittal as accountRejectTransmittalAction,
 	accountBook as accountBookAction,
	accountForCollection as accountForCollectionAction,
	accountProceedsCollected as accountProceedsCollectedAction,
	accountDiCollected as accountDiCollectedAction,
} from '../actions/AccountActions'
import DateTimePicker from 'material-ui-datetimepicker';
import DatePickerDialog from 'material-ui/DatePicker/DatePickerDialog'
import TimePickerDialog from 'material-ui/TimePicker/TimePickerDialog';

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { dateString } from '../util'

class ConfirmTranmittalButton extends React.Component {
	state = {
		open: false,
		dateTime: new Date(),
	};

	setDate = (dateTime) => this.setState({ dateTime })

	handleOpen = () => {
		const { record } = this.props;
		const { fields } = record
		if ( ! fields.has_doc_def && ! fields.doc_defs ) {
			this.setState({ dateTime: new Date() })
			this.setState({ open: true })
		} else {
			this.confirmTransmittal()
		}
	};

	handleSave = () => {
		this.confirmTransmittal()
		this.setState({open: false});
	};

	handleCancel = () => {
		this.setState({open: false});
	};

	confirmTransmittal = () => {
		const { accountConfirmTransmittal, record } = this.props;
		accountConfirmTransmittal(record.id, record, dateString( this.state.dateTime ) )
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Confirm Transmittal"
				primary={true}
				onClick={this.handleSave}
			/>,
		];

		return (
			<div>
				<RaisedButton label="Confirm Transmittal" icon={<ActionAssignmentTurnedIn />} primary={true} onClick={this.handleOpen} style={{ margin: 10 }} {...this.props.options} />
				<Dialog
					title="Enter Date of Bank Receipt"
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
					>
					<DateTimePicker
						value={this.state.dateTime}
				        onChange={this.setDate}
				        DatePicker={DatePickerDialog}
				        TimePicker={TimePickerDialog}
						format="MM/DD/YYYY h:mm a"
				      />
				</Dialog>
			</div>
		);
	}
}

class RejectTranmittalButton extends React.Component {
	state = {
		open: false,
		dateTime: new Date(),
		reason: '',
	};

	handleOpen = () => {
		this.setState({ dateTime: new Date() })
		this.setState({ open: true })
	};

	handleSave = () => {
		this.rejectTransmittal()
		this.setState({open: false});
	};

	handleCancel = () => {
		this.setState({open: false});
	};

	reasonChanged = (e) => this.setState({ reason: e.target.value.replace( /^\s+$/, '' ) })

	rejectTransmittal = () => {
		const { accountRejectTransmittal, record } = this.props;
		record.fields.transmittal_rejection_reason = this.state.reason.trim()
		accountRejectTransmittal(record.id, record, dateString( this.state.dateTime ) )
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Reject Transmittal"
				primary={true}
				onClick={this.handleSave}
				disabled={ ! this.state.reason }
			/>,
		];

		return (
			<div>
				<RaisedButton label="Reject Transmittal" icon={<ActionAssignmentLate />} secondary={true} onClick={this.handleOpen} style={{ margin: 10 }} {...this.props.options} />
				<Dialog
					title="Enter Reason for Rejection"
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
					>
					<TextField 
						floatingLabelText="Rejection reason" 
						errorText={ this.state.reason ? '' : 'This is required' }
						multiLine={true} 
						value={this.state.reason} 
						onChange={this.reasonChanged} 
						fullWidth 
						rows={2} 
						rowsMax={4} 
					/>
				</Dialog>
			</div>
		);
	}
}

/**
 * Book button with modal confirmation.
 */
class BookButton extends React.Component {
	state = {
		open: false,
	};

	handleOpen = () => {
		const { record } = this.props;
		const { fields } = record
		if ( ! fields.has_doc_def && ! fields.doc_defs ) {
			this.setState({open: true});
		} else {
			this.bookAccount()
		}
	};

	handleBook = () => {
		this.bookAccount()
		this.setState({open: false});
	};

	handleCancel = () => {
		this.setState({open: false});
	};

	bookAccount = () => {
		const { accountBook, record } = this.props;
		accountBook(record.id, record)
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Book without Doc Def"
				primary={true}
				onClick={this.handleBook}
			/>,
		];

		return (
			<div>
				<RaisedButton label="Book" icon={<ActionBook />} primary={true} onClick={this.handleOpen} style={{ margin: 10 }} {...this.props.options} />
				<Dialog
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
					>
					Confirm <strong>Booking</strong> without doc def?
				</Dialog>
			</div>
		);
	}
}

/**
 * For collection button with modal confirmation.
 */
class ForCollectionButton extends React.Component {
	state = {
		open: false,
	};

	handleOpen = () => {
		const { record } = this.props;
		const { fields } = record
		if ( ! fields.has_doc_def && ! fields.doc_defs ) {
			this.setState({open: true});
		} else {
			this.forCollectionAccount()
		}
	};

	handleForCollection = () => {
		this.forCollectionAccount()
		this.setState({open: false});
	};

	handleCancel = () => {
		this.setState({open: false});
	};

	forCollectionAccount = () => {
		const { accountForCollection, record } = this.props;
		accountForCollection(record.id, record)
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="For Collection without Doc Def"
				primary={true}
				onClick={this.handleForCollection}
			/>,
		];

		return (
			<div>
				<RaisedButton label="For Collection" icon={<ActionCreditCard />} primary={true} onClick={this.handleOpen} style={{ margin: 10 }} {...this.props.options} />
				<Dialog
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
					>
					Confirm <strong>For Collection</strong> without doc def?
				</Dialog>
			</div>
		);
	}
}

/**
 * Proceeds collected button with modal confirmation.
 */
class ProceedsCollectedButton extends React.Component {
	state = {
		open: false,
		openAsk: false,
		proceedsAmount: '',
		proceedsType: 'credit',
		error: '',
		dateTime: new Date(),
		ORNumber: '',
		checkNo: '',
		remarks: '',
	};

	setDate = (dateTime) => this.setState({ dateTime })

	handleOpen = () => {
		const { record } = this.props;
		const { fields } = record
		if ( ! fields.has_doc_def && ! fields.doc_defs ) {
			this.setState({ 
				dateTime: new Date(),
				open: true,
				remarks: fields.proceeds_collection_notes,
			})
		} else {
			this.handleProceedsCollected()
		}
	};

	handleProceedsCollected = () => {
		this.setState({openAsk: true})
		this.setState({open: false});
	};

	handleCancel = () => {
		this.setState({open: false});
		this.setState({openAsk: false})
	};

	handleProceedsAmount = () => {
		if ( this.state.error ) {
			return;
		}
		this.handleCancel()
		const { accountProceedsCollected, record } = this.props;
		record.fields.proceeds_collected = this.state.proceedsAmount.replace( /,/g, '' )
		record.fields.proceeds_collected_type = this.state.proceedsType
		record.fields.proceeds_collected_or_number = this.state.ORNumber
		record.fields.proceeds_collection_notes = this.state.remarks
		record.fields.proceeds_collected_check_number = this.state.checkNo
		accountProceedsCollected(record.id, record, dateString( this.state.dateTime ))
	}

	proceedsAmountChanged = (e) => this.setState({ proceedsAmount: e.target.value })
	
	proceedsTypeChanged = (event, index, value) => this.setState({ proceedsType: value })

	proceedsRemarksChanged = (e) => this.setState({ remarks: e.target.value })

	orChanged = (e) => this.setState({ ORNumber: e.target.value })

	checkNoChanged = e => this.setState( { checkNo: e.target.value } )

	format = (e) => {
		const num = parseFloat( e.target.value )
		const formattedNum = parseFloat( e.target.value.replace( /,/g, '' ) ).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
		const newState = {
			proceedsAmount: ! isNaN( num ) ? formattedNum : e.target.value,
		 	error: '',
		};

		if ( isNaN( num ) ) {
			newState.error = 'Please enter a valid amount'
		}

		this.setState(newState)
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Proceeds Collected without Doc Def"
				primary={true}
				onClick={this.handleProceedsCollected}
			/>,
		];

		const actions2 = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Submit"
				primary={true}
				onClick={this.handleProceedsAmount}
			/>,
		];

		return (
			<div>
				<RaisedButton label="Proceeds Collected" icon={<ActionDone />} primary={true} onClick={this.handleOpen} style={{ margin: 10 }} {...this.props.options} />
				<Dialog
					title="Are you sure?"
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
					>
					Confirm <strong>Proceeds Collected</strong> without doc def?
				</Dialog>
				<Dialog
					title="Proceeds Collected"
					actions={actions2}
					modal={false}
					open={this.state.openAsk}
					onRequestClose={this.handleCancel}
					>
					<TextField floatingLabelText="Amount of Proceeds Collected (Php)" value={this.state.proceedsAmount} onChange={this.proceedsAmountChanged} onBlur={this.format} errorText={this.state.error} autoFocus fullWidth/>
					<TextField floatingLabelText="OR Number" value={this.state.ORNumber} onChange={this.orChanged} />
					<DateTimePicker
						floatingLabelText="Time of Collection"
						value={this.state.dateTime}
				        onChange={this.setDate}
				        DatePicker={DatePickerDialog}
				        TimePicker={TimePickerDialog}
						format="MM/DD/YYYY h:mm a" />
					<SelectField floatingLabelText="Type" value={this.state.proceedsType} onChange={this.proceedsTypeChanged}>
						<MenuItem value="credit" primaryText="Credit to account" />
						<MenuItem value="check" primaryText="Check" />
					</SelectField>
					{ this.state.proceedsType === 'check' &&
						<TextField floatingLabelText="Check Number" value={this.state.checkNo} onChange={this.checkNoChanged} style={{ display: 'block' }} />
					}
					<TextField floatingLabelText="Collection Remarks" multiLine={true} value={this.state.remarks} onChange={this.proceedsRemarksChanged} fullWidth rows={2} rowsMax={4} />
				</Dialog>
			</div>
		);
	}
}

/**
 * DI collected button with modal confirmation.
 */
class DICollectedButton extends React.Component {
	state = {
		open: false,
		diAmount: '',
		diType: 'credit',
		error: '',
		dateTime: new Date(),
		ORNumber: '',
		checkNo: '',
		remarks: '',
	};

	setDate = (dateTime) => this.setState({ dateTime })

	handleOpen = () => {
		const { record } = this.props;
		const { fields } = record
		this.setState({
			open: true,
			remarks: fields.di_collection_notes,
		})
	};

	handleCancel = () => {
		this.setState({open: false});
	};

	handleDiAmount = () => {
		if ( this.state.error ) {
			return;
		}
		this.handleCancel()
		const { accountDiCollected, record } = this.props
		record.fields.di_collected = this.state.diAmount.replace( /,/g, '' )
		record.fields.di_collected_type = this.state.diType
		record.fields.di_collected_or_number = this.state.ORNumber
		record.fields.di_collection_notes = this.state.remarks
		record.fields.di_collected_check_number = this.state.checkNo
		accountDiCollected(record.id, record, dateString( this.state.dateTime ))
	}

	diAmountChanged = (e) => this.setState({ diAmount: e.target.value })

	diTypeChanged = (event, index, value) => this.setState({ diType: value })

	orChanged = (e) => this.setState({ ORNumber: e.target.value })

	checkNoChanged = e => this.setState( { checkNo: e.target.value } )

	diRemarksChanged = (e) => this.setState({ remarks: e.target.value })

	format = (e) => {
		const num = parseFloat( e.target.value )
		const formattedNum = parseFloat( e.target.value.replace( /,/g, '' ) ).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
		const newState = {
			diAmount: ! isNaN( num ) ? formattedNum : e.target.value,
		 	error: '',
		};

		if ( isNaN( num ) ) {
			newState.error = 'Please enter a valid amount'
		}

		this.setState(newState)
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.handleCancel}
			/>,
			<FlatButton
				label="Submit"
				primary={true}
				onClick={this.handleDiAmount}
			/>,
		];

		return (
			<div>
				<RaisedButton label="DI Collected" icon={<ActionDoneAll />} primary={true} onClick={this.handleOpen} style={{ margin: 10 }}  disabled={this.props.disabled} {...this.props.options}/>
				<Dialog
					title="DI Collected"
					actions={actions}
					modal={false}
					open={this.state.open}
					onRequestClose={this.handleCancel}
					>
					<TextField floatingLabelText="Amount of DI Collected (Php)" value={this.state.diAmount} onChange={this.diAmountChanged} onBlur={this.format} errorText={this.state.error} autoFocus fullWidth/>
					<TextField floatingLabelText="OR Number" value={this.state.ORNumber} onChange={this.orChanged} />
					<DateTimePicker
						floatingLabelText="Time of Collection"
						value={this.state.dateTime}
						onChange={this.setDate}
						DatePicker={DatePickerDialog}
						TimePicker={TimePickerDialog}
						format="MM/DD/YYYY h:mm a" />
					<SelectField floatingLabelText="Type" value={this.state.diType} onChange={this.diTypeChanged}>
						<MenuItem value="credit" primaryText="Credit to account" />
						<MenuItem value="check" primaryText="Check" />
					</SelectField>
					{ this.state.diType === 'check' &&
						<TextField floatingLabelText="Check Number" value={this.state.checkNo} onChange={this.checkNoChanged} style={{ display: 'block' }} />
					}
					<TextField floatingLabelText="Collection Remarks" multiLine={true} value={this.state.remarks} onChange={this.diRemarksChanged} fullWidth rows={2} rowsMax={4} />
				</Dialog>
			</div>
		);
	}
}

class CollectorButtons extends Component {

    render() {
        const { record } = this.props;
		const { fields } = record;
		const { status } = fields
		let confirmTransmittalButton,
			rejectTransmittalButton,
			bookButton,
			forCollectionButton,
			proceedsCollectedButton,
			diCollectedButton = null;
		if ( status === 'transmitted' ) {
			confirmTransmittalButton = <ConfirmTranmittalButton {...this.props} />
			rejectTransmittalButton = <RejectTranmittalButton {...this.props} />
		}
		if ( status === 'review' ) {
			bookButton = <BookButton {...this.props} />
		}
		if ( status === 'booking' ) {
			forCollectionButton = <ForCollectionButton {...this.props} />
		}
		if ( status === 'for_collection' ) {
			proceedsCollectedButton = <ProceedsCollectedButton {...this.props} />
		}
		if ( status === 'proceeds_collected' ) {
			diCollectedButton = <DICollectedButton {...this.props} disabled={ fields.has_doc_def }/>
		}

        return (
            <span>
				{confirmTransmittalButton}
				{rejectTransmittalButton}
				{bookButton}
				{forCollectionButton}
				{proceedsCollectedButton}
				{diCollectedButton}
            </span>
        );
    }
}

CollectorButtons.propTypes = {
    record: PropTypes.object,
	refreshView: PropTypes.func,
	accountConfirmTransmittal: PropTypes.func,
	accountRejectTransmittal: PropTypes.func,
	accountBook: PropTypes.func,
	accountForCollection: PropTypes.func,
	accountProceedsCollected: PropTypes.func,
	accountDiCollected: PropTypes.func,
	push: PropTypes.func,
};

export default connect(null, {
	refreshView: refreshViewAction,
	accountConfirmTransmittal: accountConfirmTransmittalAction,
	accountRejectTransmittal: accountRejectTransmittalAction,
	accountBook: accountBookAction,
	accountForCollection: accountForCollectionAction,
	accountProceedsCollected: accountProceedsCollectedAction,
	accountDiCollected: accountDiCollectedAction,
	push: pushAction,
})(CollectorButtons);



// WEBPACK FOOTER //
// ./src/CollectorAccount/CollectorButtons.js